import { ServiceStateEnum } from '@mwe/constants';
import { BadgeType, IBulletConfirmationStatusChangeResponse } from '@mwe/models';
// eslint-disable-next-line sonarjs/redundant-type-aliases
export type StepIdentifier = string; // Identifies Step in a Process
// eslint-disable-next-line sonarjs/redundant-type-aliases
export type SubmitIdentifier = number; // Identifies a Backend Process

export const DEFAULT_ICON_MAP = new Map<ServiceStateEnum, string>([
  [ServiceStateEnum.INIT, 'fa-clock'],
  [ServiceStateEnum.LOADED, 'fa-clock'],
  [ServiceStateEnum.INFO, 'fa-exclamation-circle'],
  [ServiceStateEnum.LOADING, 'fa-cog-circle'],
  [ServiceStateEnum.SUCCESS, 'fa-check-circle'],
  [ServiceStateEnum.ERROR, 'fa-circle-xmark'],
  [ServiceStateEnum.FAILED, 'fa-circle-xmark'],
]);

export const DEFAULT_STATE_MAP = new Map<ServiceStateEnum, BadgeType>([
  [ServiceStateEnum.INIT, 'neutral'],
  [ServiceStateEnum.LOADED, 'neutral'],
  [ServiceStateEnum.INFO, 'info'],
  [ServiceStateEnum.LOADING, 'neutral'],
  [ServiceStateEnum.SUCCESS, 'success'],
  [ServiceStateEnum.ERROR, 'danger'],
  [ServiceStateEnum.FAILED, 'danger'],
]);

export const DEFAULT_STATE_LABEL_MAP = new Map<ServiceStateEnum, string>([
  [ServiceStateEnum.INIT, 'globalConfirmation.stepState.init'],
  [ServiceStateEnum.LOADED, 'globalConfirmation.stepState.inProgress'],
  [ServiceStateEnum.INFO, 'globalConfirmation.stepState.inProgress'],
  [ServiceStateEnum.LOADING, 'globalConfirmation.stepState.init'],
  [ServiceStateEnum.SUCCESS, 'globalConfirmation.stepState.success'],
  [ServiceStateEnum.ERROR, 'globalConfirmation.stepState.error'],
  [ServiceStateEnum.FAILED, 'globalConfirmation.stepState.error'],
]);

// A Step that can be rendered (i.E. as a bullet). No optional values are allowed.
export interface StepText {
  title: string;
  label: string | string[];
}
export interface StepInterface extends StepText {
  stepId: StepIdentifier;
  translationParams: object;
  iconMap: Map<ServiceStateEnum, string>;
  stateMap: Map<ServiceStateEnum, string>;
  stateLabelMap: Map<ServiceStateEnum, string>;
  textMap: Map<ServiceStateEnum, Partial<StepText>>;
}

// The StepDefinition only requires a stepId and a title. The rest will be filled with default values if not provided.
export type StepDefinition = Partial<StepInterface> & Required<Pick<StepInterface, 'stepId' | 'title'>>;

// Class to handle default values for a Step
export function buildStepFromDefinition(step: StepDefinition): StepInterface {
  return {
    iconMap: DEFAULT_ICON_MAP,
    stateMap: DEFAULT_STATE_MAP,
    stateLabelMap: DEFAULT_STATE_LABEL_MAP,
    textMap: new Map<ServiceStateEnum, StepText>(),
    translationParams: {},
    label: [],
    ...step,
  } as StepInterface;
}

// The state that can be mapped to a Step
export interface StepStateInterface {
  state: ServiceStateEnum;
  errorCode?: IBulletConfirmationStatusChangeResponse['errorCode'];
  retryAllowed?: boolean;
}

export type IdentifyableAsStep = StepInterface | StepIdentifier | StepInterface[] | StepIdentifier[];
